import {Injectable, SecurityContext} from '@angular/core';
import {Location} from '@angular/common';
import {ActivatedRoute, Router, UrlSerializer} from "@angular/router";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {SearchUrlParameters} from "../model/search-url-parameters";
import {DomSanitizer} from "@angular/platform-browser";

@Injectable({
  providedIn: 'root'
})
export class RouteParamService {

  constructor(private serializer: UrlSerializer,
              private activatedRoute: ActivatedRoute/*,
              private sanitizer: DomSanitizer*/) {

  }

  getSearchStateFromRouteParam(): Observable<SearchUrlParameters> {
    return this.activatedRoute.queryParams.pipe(map(params => {
      const searchParams: SearchUrlParameters = {...params};

      /*searchParams.q = this.sanitizer.sanitize(SecurityContext.HTML, params['q']) || undefined;
      searchParams.aq = this.sanitizer.sanitize(SecurityContext.HTML, params['aq']) || undefined;
      searchParams.sn = this.sanitizer.sanitize(SecurityContext.HTML, params['sn']) || undefined;
      searchParams.sb = this.sanitizer.sanitize(SecurityContext.HTML, params['sb']) || undefined;
      searchParams.fil = this.sanitizer.sanitize(SecurityContext.HTML, params['fil']) || undefined;*/

      if (params.ps) {
        searchParams.ps = parseInt(params.ps, 10) || undefined;
      }
      if (params.pg) {
        searchParams.pg = parseInt(params.pg, 10) || undefined;
      }
      return searchParams;
    }));
  }


}
